'use client'

import * as React from 'react'

import { cn } from '@/utils'

import { FieldTooltip } from './FieldTooltip'
import { Input } from './Input'

export const fieldErrorCls = cn('type-body-caption mt-1 text-left text-error')

export const fieldLabelCls = cn('type-body-medium mb-2 font-semibold')

export type TInputFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
	label?: string
	error?: string
	leftIcon?: React.ComponentType<{ className?: string }> | null
	rightIcon?: React.ComponentType<{ className?: string }> | null
	rightOnClick?: () => void
	inputClassName?: string
  labelClassName?: string
	tooltip?: string
}

const InputField = React.forwardRef<HTMLInputElement, TInputFieldProps>(
	({ label, error, inputClassName, labelClassName, className, tooltip, ...props }, ref) => {
		const input = (
			<Input
				ref={ref}
				id={props.id || label}
				error={!!error}
				className={cn(
					!tooltip && label && 'mt-2',
					tooltip && 'pr-11',
					inputClassName,
				)}
				{...props}
			/>
		)

		return (
			<div className={className}>
				{label ? (
					<label
						htmlFor={props.id || label}
						className={cn(fieldLabelCls, labelClassName)}
					>
						{label}
						{props.required ? '*' : ''}
					</label>
				) : null}
				{tooltip ? (
					<div className={cn('relative', label && 'mt-2')}>
						{input}
						<FieldTooltip
							content={tooltip}
							className="absolute right-4 top-1/2 -translate-y-1/2"
						/>
					</div>
				) : (
					input
				)}
				{error && <p className={fieldErrorCls}>{error}</p>}
			</div>
		)
	},
)
InputField.displayName = 'InputField'

export { InputField }
